import { Pagination, Dropdown, Popover } from "antd";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const Paget = ({ status, setStatus, setCardData, search }) => {
  const PsOrders = useSelector((state) => state.PsOrders);
  console.log(PsOrders);
  const SelectedCompanyVendor = useSelector(
    (state) => state.SelectedCompanyVendor
  );

  const router = useNavigate();
  const dispatch = useDispatch();
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [pagewithsearch, setPagewithsearch] = useState(1);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  // const [status, setStatus] = useState(false);
  const [afterApi, setAfterApi] = useState(false);
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const [orderData, setOrderData] = useState([]);
  const role = useSelector((state) => state.role);
  console.log(PsOrders);

  useEffect(() => {
    if (user === "employee" && role === "Permanent Secretary") {
      if (PsOrders.value === "all-orders") {
        setStatus(null);
        return;
      }
      if (PsOrders.value === "my-orders") {
        setStatus(null);
        return;
      }
      setStatus(PsOrders?.value);
    }
  }, []);

  const statusStyles = {
    "awaited-ps": {
      bg: "bg-gray-100",
      text: "text-gray-800",
      label: "Awaited PS",
    },
    "ps-rejected": {
      bg: "bg-red-100",
      text: "text-red-800",
      label: "PS Rejected",
    },
    "ps-approved": {
      bg: "bg-green-100",
      text: "text-green-800",
      label: "PS Approved",
    },
    "submitted": { 
      bg: "bg-blue-200", 
      text: "text-blue-700", 
      label: "Order Submitted" 
    },
    "re-submitted": {
      bg: "bg-blue-200",
      text: "text-blue-700",
      label: "Re-Submitted",
    },
    "in-progress": {
      bg: "bg-yellow-100",
      text: "text-[#e0aa36]",
      label: "In Progress",
    },
    "partial": { 
      bg: "bg-orange-100", 
      text: "text-orange-800", 
      label: "Partial" 
    },
    "partially-in-progress": {
      bg: "bg-yellow-200",
      text: "text-yellow-800",
      label: "Partially In Progress",
    },
    "partially-shipped": {
      bg: "bg-purple-200",
      text: "text-purple-800",
      label: "Partially Shipped",
    },
    "shipped": { 
      bg: "bg-purple-100", 
      text: "text-purple-800", 
      label: "Shipped" 
    },
    "partially-delivered": {
      bg: "bg-teal-200",
      text: "text-teal-800",
      label: "Partially Delivered",
    },
    "delivered": { 
      bg: "bg-teal-100", 
      text: "text-teal-800", 
      label: "Delivered" 
    },
    "delivered-issue": {
      bg: "bg-pink-100",
      text: "text-pink-800",
      label: "Delivered Issue",
    },
    "recieved": {
      bg: "bg-indigo-100",
      text: "text-indigo-800",
      label: "Received",
    },
    "partially-recieved": {
      bg: "bg-indigo-200",
      text: "text-indigo-800",
      label: "Partially Received",
    },
    "cancelled": {
      bg: "bg-red-200",
      text: "text-red-800",
      label: "Cancelled",
    },
   "buyer-partial-accepted": {
  bg: "bg-cyan-200", // Light Cyan for a soft neutral approval
  text: "text-cyan-800", // Dark Cyan for readability
  label: "Partial Order Accepted",
}
  };
  

  const onClick = (key, item) => {
    console.log(key, item);
  };

  const columnHeaders = [
    "SR.",
    "PO#",
    "Order Date",
    user === "vendor-owner" ? "Buyer" : "Vendor",
    // "Phone",
    "Product",
    "Delivery Required On",
    // "Amount",
    // "Quantity",
    // "Delivered On",
    "Status",
  ];

  useEffect(() => {
    setAfterApi(false);
    const delay = 200;

    const timeoutId = setTimeout(() => {
      // Cancel the previous request if it exists
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }

      // Create a new cancel token source for this request
      const newCancelTokenSource = axios.CancelToken.source();
      setCancelTokenSource(newCancelTokenSource);

      const params = {
        limit: 6,
        skip: (page - 1) * 6,
        sortBy: "orderDate:desc",
        page: page,
        ...(status && { finalStatus: status }),
        ...(search && { search }),
        // limit: 6,
        // skip:
        //   search || searchDob || countryCode || phoneNoo ? 0 : (page - 1) * 6,
        // page: search ? pagewithsearch : page, // Separate page for search and non-search scenarios
        // sortBy: "createdAt:desc",

        // ...(searchDob && { dateOfBirth: searchDob }),
        // ...(countryCode &&
        //   phoneNoo && { countryCode: `+${countryCode}`, phoneNo: phoneNoo }),
      };
      if (user === "vendor-owner") {
        if (SelectedCompanyVendor !== null) {
          params.vendorbranchId = SelectedCompanyVendor?.id;
        }
      }

      fetchOrders(params, newCancelTokenSource);
    }, delay);

    return () => {
      clearTimeout(timeoutId);

      // Cancel the request if the component is unmounted
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }
    };
  }, [page, pagewithsearch, status, search]);

  const fetchOrders = (params, cancelTokenSource) => {
    // const api =
    //   user === "vendor-owner"
    //     ? "v1/inv-order/vendor-list-orders"
    //     : (user === "employee" && role === "Permanent Secretary") || user === "superadmin"
    //     ? "v1/inv-order/mhsss-list-orders"
    //     : "v1/inv-order/buyer-list-orders";

    const api =
      user === "vendor-owner"
        ? "v1/inv-order/vendor-list-orders"
        : PsOrders?.value === "all-orders" || PsOrders?.value === "awaited-ps"
        ? "v1/inv-order/mhsss-list-orders"
        : "v1/inv-order/buyer-list-orders";
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/${api}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        cancelToken: cancelTokenSource.token,
      })
      .then((data) => {
        setOrderData(data?.data?.rows);
        setTotalPages(data?.data?.totalPages);
        setAfterApi(true);
      })
      .catch((err) => {
        console.log(err);
        setAfterApi(true);
      });
  };

  //get Counts

  useEffect(() => {
    const api =
      user === "vendor-owner"
        ? SelectedCompanyVendor !== null
          ? `v1/inv-order/vendor-counts?vendorbranchId=${SelectedCompanyVendor?.id}`
          : "v1/inv-order/vendor-counts"
        : PsOrders?.value === "all-orders" || PsOrders?.value === "awaited-ps"
        ? "v1/inv-order/mhsss-counts"
        : "v1/inv-order/buyer-counts";

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/${api}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setCardData(response?.data || {});
        setAfterApi(true);
      })
      .catch((err) => {
        setAfterApi(true);
      });
  }, [user, PsOrders, SelectedCompanyVendor, token]);

  const pageHandler = (e) => {
    if (search) {
      // If searching, update searchPage
      setPagewithsearch(e);
    } else {
      // If not searching, update page
      setPage(e);
    }
  };

  return (
    <>
      <section className="w-full pl-6 pr-6 mb-5">
        <div className="mx-auto max-w-screen-3xl ">
          <div className="relative sm:rounded-lg overflow-hidden">
            {/* Search */}
            <div className="flex justify-end mt-4 gap-3 mb-3">
              {/* <div className="flex items-center bg-[#f9fbfb] border border-gray-300 rounded-md px-4 py-2 w-[300px] shadow-sm">
                <input
                  type="text"
                  placeholder="Search Order"
                  className="bg-transparent focus:outline-none text-gray-500 placeholder-gray-400 flex-grow"
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-[#1BA397]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.8"
                    d="M11 19a8 8 0 100-16 8 8 0 000 16zm5-1l5 5"
                  />
                </svg>
              </div> */}
            </div>
            <div className="overflow-x-auto w-full h-full rounded-tl-lg rounded-tr-lg custom-scrollbar">
              <table className="w-full text-sm text-left text-gray-500 ">
                <thead className="text-xs  uppercase bg-primary text-white">
                  <tr>
                    {columnHeaders.map((columnHeader) => (
                      <th
                        scope="col"
                        className="px-4 py-3 font-semibold tracking-wider whitespace-nowrap"
                      >
                        {columnHeader}
                      </th>
                    ))}
                  </tr>
                </thead>
                {orderData?.length === 0 ? (
                  <tbody>
                    <tr>
                      <td
                        colSpan="9"
                        className="text-center text-gray-500 text-lg"
                      >
                        <p className="p-10">No data found</p>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {orderData?.map((data, index) => (
                      <tr
                        onClick={() => {
                          dispatch({ type: "QUOTATION_FLOW", num: false });
                          dispatch({ type: "ORDER_DATA", num: data });
                          router("/Inventory-Vendor-Orders-Details");
                        }}
                        className={`border-b border-[1px] border-[#d9d9d970] hover:bg-gray-200 text-md cursor-pointer ${
                          index % 2 === 0 ? "bg-white" : "bg-[#f2faf9]"
                        }`}
                      >
                        <th
                          scope="row"
                          className="px-4 py-3 font-medium text-gray-900  whitespace-nowrap "
                        >
                          {search
                            ? index + 1 + (pagewithsearch - 1) * 6
                            : index + 1 + (page - 1) * 6}
                          .
                        </th>
                        <td className="px-4 py-3 whitespace-nowrap capitalize">
                          <Popover content={data?.purchasedNo}>
                            <div className="inline-block  items-center justify-center max-w-[120px] whitespace-nowrap overflow-hidden overflow-ellipsis">
                              {data?.purchasedNo.substring(0, 5)}..
                            </div>
                          </Popover>
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap capitalize">
                          <div className="flex flex-col">
                            <p className="text-gray-500 font-semibold">
                              {moment(data?.orderDate).format("MM/DD/YYYY")}
                            </p>
                            <p className="text-gray-400 font-semibold">
                              {moment(data?.orderDate).format("hh:mm A")}
                            </p>
                          </div>
                        </td>

                        <td
                          className={`${
                            user === "vendor-owner" ? "px-6 py-5" : "hidden"
                          }`}
                        >
                          {data?.user?.person?.firstName
                            ? data?.user?.person?.firstName
                            : "-----"}{" "}
                          {data?.user?.person?.lastName
                            ? data?.user?.person?.lastName
                            : ""}
                        </td>

                        <td
                          className={`${
                            user === "vendor-owner" ? "hidden" : "px-6 py-5"
                          }`}
                        >
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              <img
                                className="h-10 w-10 rounded-full border-2 border-primary"
                                src={
                                  data?.invorderitems?.[0]?.vendorbranch
                                    ? data?.invorderitems?.[0]?.vendorbranch
                                        ?.logo
                                    : data?.invorderitems?.[0]?.vendorcompany
                                        ?.logo
                                }
                                alt=""
                              />
                            </div>
                            <div className="ml-4">
                              {data?.invorderitems?.[0]?.vendorbranch
                                ? data?.invorderitems?.[0]?.vendorbranch?.name
                                : data?.invorderitems?.[0]?.vendorcompany?.name}
                            </div>
                          </div>
                        </td>

                    
                       

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            {data?.invorderitems
                              ?.slice(0, 3)
                              .map((item, index) => {
                                // Find the cover image from the invproductgallaries array
                                const coverImage =
                                  item.invproduct?.invproductgallaries?.find(
                                    (gallery) => gallery.isCoverImg
                                  )?.image;

                                return (
                                  <img
                                    key={item.id}
                                    src={
                                      coverImage ||
                                      "https://via.placeholder.com/40"
                                    } // Fallback image URL
                                    alt={item.invproduct?.name || "Product"}
                                    className={`w-10 h-10 rounded-full border-2 border-blueGray-50 shadow ${
                                      index > 0 ? "-ml-4" : ""
                                    }`}
                                  />
                                );
                              })}

                            {/* Show +n for remaining items */}
                            {data?.invorderitems?.length > 3 && (
                              <span className=" w-10 h-10 flex items-center justify-center  text-blueGray-700 text-sm font-semibold ml-2">
                                +{data.invorderitems.length - 3}
                              </span>
                            )}
                          </div>
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap capitalize">
                          <div className="flex flex-col">
                            <p className="text-gray-500 font-semibold">
                              {data?.deliveryRequiredOn ? moment(data?.deliveryRequiredOn)?.format("MM/DD/YYYY") :"------"}
                              
                            </p>
                           
                          </div>
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap">
                          {(() => {
                            const firstStatus =
                              data?.invorderstatuses?.[0]?.status ||
                              data?.finalStatus;
                            const cancelledBy = data?.invorderstatuses?.[0]
                              ?.userId
                              ? "buyer"
                              : "vendor"; // Get who cancelled

                            let label =
                              statusStyles[firstStatus]?.label || firstStatus;
                            if (firstStatus === "cancelled") {
                              label =
                                cancelledBy === "vendor"
                                  ? "Vendor Cancelled"
                                  : "Buyer Cancelled";
                            }

                            const { bg, text } = statusStyles[firstStatus] || {
                              bg: "bg-gray-100",
                              text: "text-gray-800",
                            };

                            return (
                              <div
                                className={`${bg} ${text} rounded-full pl-3 pr-3 p-1 text-center font-semibold capitalize`}
                              >
                                {label}
                              </div>
                            );
                          })()}
                        </td>

                        {/* <td className="px-4 py-3 whitespace-nowrap">
                          <div
                            className={`${
                              data?.finalStatus === "awaited-ps"
                                ? "bg-gray-100 text-gray-800" // Awaited PS
                                : data?.finalStatus === "ps-rejected"
                                ? "bg-red-100 text-red-800" // PS Rejected
                                : data?.finalStatus === "ps-approved"
                                ? "bg-green-100 text-green-800" // PS Approved
                                : data?.finalStatus === "submitted" ||
                                  data?.finalStatus === "re-submitted"
                                ? "bg-blue-200 text-blue-700" // Submitted or Re-Submitted
                                : data?.finalStatus === "in-progress"
                                ? "bg-yellow-100 text-[#e0aa36]" // In Progress
                                : data?.finalStatus === "partial"
                                ? "bg-orange-100 text-orange-800" // Partial
                                : data?.finalStatus === "shipped"
                                ? "bg-purple-100 text-purple-800" // Shipped
                                : data?.finalStatus === "delivered"
                                ? "bg-teal-100 text-teal-800" // Delivered
                                : data?.finalStatus === "delivered-issue"
                                ? "bg-pink-100 text-pink-800" // Delivered with Issue
                                : data?.finalStatus === "recieved"
                                ? "bg-indigo-100 text-indigo-800" // Received
                                : data?.finalStatus === "cancelled"
                                ? "bg-red-200 text-red-800" // Cancelled
                                : "bg-gray-100 text-gray-800" // Default Style
                            } rounded-full pl-3 pr-3 p-1 text-center font-semibold capitalize`}
                          >
                            {data?.finalStatus === "awaited-ps"
                              ? "Awaited PS"
                              : data?.finalStatus === "ps-rejected"
                              ? "PS Rejected"
                              : data?.finalStatus === "ps-approved"
                              ? "PS Approved"
                              : data?.finalStatus === "submitted"
                              ? "Submitted"
                              : data?.finalStatus === "re-submitted"
                              ? "Re-Submitted"
                              : data?.finalStatus === "in-progress"
                              ? "In Progress"
                              : data?.finalStatus === "partial"
                              ? "Partial"
                              : data?.finalStatus === "shipped"
                              ? "Shipped"
                              : data?.finalStatus === "delivered"
                              ? "Delivered"
                              : data?.finalStatus === "delivered-issue"
                              ? "Delivered Issue"
                              : data?.finalStatus === "recieved"
                              ? "Received"
                              : data?.finalStatus === "cancelled"
                              ? "Cancelled"
                              : data?.finalStatus}
                          </div>
                        </td> */}
                        {/* <td className="px-6  py-5">
                          <Dropdown
                            menu={{
                              items,
                              onClick: (key) => onClick(key, items),
                            }}
                            trigger={["click"]}
                            onClick={() => {}}
                          >
                            <div className="w-[2.8rem] flex gap-1 cursor-pointer bg-[#f5f6fb] justify-center items-center h-[1.2rem] rounded-[1rem]">
                              <div className="h-[4px] w-[4px] rounded-full bg-gray-900"></div>
                              <div className="h-[4px] w-[4px] rounded-full bg-gray-900"></div>
                              <div className="h-[4px] w-[4px] rounded-full bg-gray-900"></div>
                            </div>
                          </Dropdown>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
            <nav
              className="flex bg-white flex-col h-[5.5rem] md:flex-row justify-center items-start md:items-center space-y-3 md:space-y-0 p-4 rounded-bl-lg rounded-br-lg"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 ">
                Showing{" "}
                <span className="font-semibold text-gray-900 ">
                  Page {page}{" "}
                </span>
                of{" "}
                <span className="font-semibold text-gray-900 ">
                  {totalPages}
                </span>
              </span>
              <div className={`flex justify-end mt-7`}>
                <Pagination
                  defaultCurrent={1}
                  total={totalPages * 10}
                  showSizeChanger={false}
                  onChange={pageHandler}
                  current={page}
                />
              </div>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
};

export default Paget;
